import React from 'react';
import logoSvg from 'assets/images/logo/logo-dark.svg?url';

const BegigLogo = (props) => {
  return <img alt='Logo' src={logoSvg} {...props} />;
};

export default BegigLogo;
